/* eslint-disable arrow-body-style */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const GoalsAndAudienceTab = () => {
  const { lang } = useTranslation('client')
  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              Goals and Audience
            </Text>
            <Text size="lg">
              At Infinity Medical Academy, our goals are aligned with providing
              high-quality training and educational services to individuals and
              organizations in healthcare.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Goals
            </Text>
            <Text size="lg">
              <span className="font-bold"> Skills Development: </span> Our goal
              is to help individuals develop the skills, knowledge, and
              competencies necessary to succeed in their professional and
              academic endeavors.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Professional Advancement: </span> We
              aim to support professionals in advancing their careers and
              achieving their professional goals.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Academic Excellence: </span> For
              students and academic professionals, our goal is to provide access
              to high-quality educational resources, research materials, and
              academic support services.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Industry Engagement: </span> We are
              committed to engaging with industry stakeholders, employers, and
              organizations to address the evolving needs of the industry.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Audience
            </Text>
            <Text size="lg">
              <span className="font-bold"> Professionals: </span> Individuals
              seeking to enhance their skills, advance their careers, or
              transition into new roles within healthcare.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Students: </span> Undergraduate and
              graduate students pursuing academic studies in health and medicals
              who seek additional resources, support, and educational
              opportunities.
            </Text>
            <Text size="lg">
              <span className="font-bold"> Organizations: </span> Companies,
              government agencies, and non-profit organizations looking to
              invest in employee training and development.
            </Text>

            <Text size="lg">
              Whether you&apos;re an experienced professional, a student, or an
              organization seeking training solutions, Infinity Medical Academy
              is dedicated to supporting your learning and development needs.
            </Text>
          </div>
        ) : (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              الأهداف والجمهور
            </Text>
            <Text size="lg">
              في أكاديمية الطب اللانهائية، تتماشى أهدافنا مع تقديم خدمات تدريبية
              وتعليمية عالية الجودة للأفراد والمنظمات في مجال الرعاية الصحية.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الأهداف
            </Text>
            <Text size="lg">
              <span className="font-bold"> تطوير المهارات: </span> هدفنا هو
              مساعدة الأفراد على تطوير المهارات والمعرفة والكفاءات اللازمة
              لنجاحهم في مساراتهم المهنية والأكاديمية.
            </Text>
            <Text size="lg">
              <span className="font-bold"> التقدم المهني: </span> نهدف إلى دعم
              المهنيين في التقدم في مساراتهم المهنية وتحقيق أهدافهم المهنية.
            </Text>
            <Text size="lg">
              <span className="font-bold"> التميز الأكاديمي: </span> بالنسبة
              للطلاب والمحترفين الأكاديميين، هدفنا هو توفير الوصول إلى موارد
              تعليمية عالية الجودة ومواد بحثية وخدمات دعم أكاديمي.
            </Text>
            <Text size="lg">
              <span className="font-bold"> المشاركة في الصناعة: </span> نحن
              ملتزمون بالتعامل مع أصحاب المصلحة في الصناعة وأصحاب العمل
              والمنظمات لمعالجة الاحتياجات المتطورة في الصناعة.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الجمهور
            </Text>
            <Text size="lg">
              <span className="font-bold"> المحترفون: </span> الأفراد الذين
              يسعون لتعزيز مهاراتهم، والتقدم في مساراتهم المهنية، أو الانتقال
              إلى أدوار جديدة في مجال الرعاية الصحية.
            </Text>
            <Text size="lg">
              <span className="font-bold"> الطلاب: </span> الطلاب الجامعيين
              والدراسات العليا الذين يسعون للدراسات الأكاديمية في الصحة والطب
              ويبحثون عن موارد إضافية ودعم وفرص تعليمية.
            </Text>
            <Text size="lg">
              <span className="font-bold"> المنظمات: </span> الشركات، والوكالات
              الحكومية، والمنظمات غير الربحية الراغبة في الاستثمار في تدريب
              وتطوير الموظفين.
            </Text>

            <Text size="lg">
              سواء كنت محترفًا ذو خبرة، أو طالبًا، أو منظمة تبحث عن حلول
              تدريبية، فإن أكاديمية الطب اللانهائية مكرسة لدعم احتياجات تعلمك
              وتطويرك.
            </Text>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default GoalsAndAudienceTab
